export default __webpack_public_path__ + "static/media/Achievements2.e40f2ad5.webp";